// extracted by mini-css-extract-plugin
export default {"container":"fP-z","title":"gP-z","link":"hP-z"};